import styled from 'styled-components';
import MdxHeader from './MdxHeader';
import { H6 } from 'UIComponents/elements/headings';
import { useDevDocsTheme } from 'developer-docs-shared-components/config/themes';
import { STANDARD_HEADER_TOP_MARGIN } from '../utils/spacing';

/**
 * A semantic H6 without `text-transform` for
 * [localization reasons](https://www.figma.com/file/zgIgBtWbQ5AwS36QCKJqMa/API-Reference-Docs-Design-Concepts?type=design&node-id=2376%3A56716&mode=dev)
 * or a redundant `aria-label`.
 */
import { jsx as _jsx } from "react/jsx-runtime";
const PublicH6 = styled.h6.withConfig({
  displayName: "MdxH6__PublicH6",
  componentId: "x5n7g4-0"
})(["text-transform:none;margin-top:", ";"], STANDARD_HEADER_TOP_MARGIN);
const StyledH6 = styled(H6).withConfig({
  displayName: "MdxH6__StyledH6",
  componentId: "x5n7g4-1"
})(["margin-top:", ";"], STANDARD_HEADER_TOP_MARGIN);
function MdxH6(props) {
  const {
    isPublicTheme
  } = useDevDocsTheme();
  return /*#__PURE__*/_jsx(MdxHeader, Object.assign({
    Component: isPublicTheme ? PublicH6 : StyledH6
  }, props));
}
export default MdxH6;